<script>
import { MenuItem } from 'element-ui';

export default {
  mixins: [MenuItem],
  name: 'nuttrema-el-menu-item-not-allowed',
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="scss">
  .el-menu-item.el-menu-item--not-allowed {
    background-color: #9e9e9e;

    &:active, &:focus, &:hover, &.is-active, &.active {
      background-color: #9e9e9e;
    }

    i, span, span i {
      color: #fff;
    }

    span {
      i {
        float: right;
        line-height: 2.5em;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/navigation/nuttrema-el-menu-item-not-allowed.vue